import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteMerchantInfo } from "../actions/deleteMerchantInfo";
import { useGlobalSnackbar } from "../../../context/SnackbarContext";

export const useDeleteMerchantInfo = () => {
  const { showSnackbar } = useGlobalSnackbar();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteMerchantInfo,
    onSuccess: () => {
      queryClient.setQueriesData({ queryKey: ["merchant-info"] }, () => null);
      showSnackbar("PayPal account disconnected successfully", "success");
    },
    onError: (error) => {
      showSnackbar(`Failed to delete merchant info: ${error.message}`, "error");
    },
  });
};